export default "__VITE_ASSET__Z90AvYZO__"